import React, {Component} from 'react';
import config from 'react-global-configuration';
import {Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
//import {Card, CardBody, CardText} from 'reactstrap';
import {Card} from 'react-bootstrap';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {Link} from "react-router-dom";
import axios from "axios";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactTooltip from 'react-tooltip';
import Select from 'react-select';
import Switch from "react-switch";
import $ from 'jquery';
import CommonNavbar, {navbar} from "./commonNavbar";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import {List} from 'react-virtualized';
import {disable} from "@amcharts/amcharts4/.internal/core/utils/Debug";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class AdminIssuerBanksList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      brand_file_uploaded: [],
      mvalue: {year: new Date().getFullYear(), month: 11},
      _notificationSystem: null,
      timer: null,
      loading: true,
      isSubmit: false,
      file_name: "",
      notify: null,
      activer: [],
      activer_copy: [],
      is_download: false,
      uploadDropdown: false,
      errorModel: false,
      noErrorModel: false,
      file_id_got: null,
      report_file_name: null,
      error_message: null,
      error_message_header: null,
      open_instructions: false,
      emiMenus: [],
      party_options: [
        {value: 'Brand', label: 'Brand'},
        {value: 'Merchant', label: 'Merchant'}
      ],
      party_list: [],
      selected_party_type: null,
      selected_party: null,
      selected_party_type2: null,
      selected_party2: null,
      upload_user_type: null,
      partyTypeID: '',
      partyTypeValue: null,
      partyID: '',
      partyValue: null,
      activer2: [],
      update_disabler: false,
      displaySchemeDiv: "none",
      enableDisablePartyType: 'none'
    };
    this.handleChange = this.handleChange.bind(this);
    this.updatePartyValue = this.updatePartyValue.bind(this);
  }

  handleNotificationClick = (position, color, msg) => {
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"/>,
      message: (
        <div>
          {msg}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 5
    });
  };

  getFileExtension(filename) {
    return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
  }

  handleChange(checked) {
    console.log(this.state.checked);
    this.setState({
      checked
    });
  }

  getBrandUploadedData() {
  const that = this;
  const token = localStorage.usertoken;
  const decoded = jwt_decode(token);
  var stringCode = decoded.object_code;
  var arrayCode = stringCode.split(",");

  if ($.fn.DataTable.isDataTable('#schemesViewTable')) {
    $('#schemesViewTable').DataTable().destroy();
  }

  var vEmiFlexyEndPoint = '';
  var vLocEmiType = localStorage.getItem('locFlexipay');

  if (vLocEmiType === '1') {
    vEmiFlexyEndPoint = "issuerBanks";
  } else {
    vEmiFlexyEndPoint = "issuerBanks";
  }

  // Load all data with a single AJAX call
  $.ajax({
    url: config.get('API_URL') + "/brandemi/" + vEmiFlexyEndPoint,
    type: "POST",
    headers: {
      "Authorization": localStorage.usertoken
    },
    data: {
      party_id: this.state.partyID
    },
    success: function(response) {
      const dataSet = response._embedded.issuerBanks || [];

      $('#schemesViewTable').DataTable({
        data: dataSet,
        order: [],
        paging: true, // Optional: Enable if you want client-side pagination
        pageLength: 20,
        bInfo: true,
        autoWidth: false,
        responsive: false,
        scrollX: true,
        lengthMenu: [[20, 50, 100, 500, -1], [20, 50, 100, 500, "All"]],
        columns: [
          { data: "innoIssuerBankCode", visible: false },
          { data: "issuerBankDisplayName", title: "Issuer Bank" },
          { data: "issuerDefaultCashbackFlag", title: "Cashback Flag" },
          { data: "issuerMinEmiAmount", title: "Min EMI Amount" },
          { data: "issuerTermsConditions", title: "T&C" },
          {
            data: "innoIssuerBankCode",
            title: "Action",
            orderable: false,
            render: function(data, type, row) {
              return `
                <a class="viewButton" data-tip="View Scheme" href="/admin/admin-issuer-bank-view/${row.innoIssuerBankCode}">
                  <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>
                </a>
                <a class="viewButton" data-tip="Edit Scheme" href="/admin/admin-issuer-bank-edit/${row.innoIssuerBankCode}">
                  <span class="glyphicon glyphicon-edit" aria-hidden="true"></span>
                </a>
              `;
            }
          }
        ]
      });
    },
    error: function(err) {
      console.error("Error fetching data:", err);
    }
  });
}


  gotoCreateSchemes = () => {
    this.props.history.push('/admin/admin-new-create-schemes-bank');
  }

  componentDidMount() {
    // Fetch party list when the component loads
    this.fetchPartyList();
    this.setState({
      partyTypeValue: [],
      partyValue: [],
      displaySchemeDiv: 'block',
      enableDisablePartyType: 'block'
    });

    localStorage.setItem('locFlexipay', '0');

    this.getBrandUploadedData();
  }

  fetchPartyList = () => {
    const token = localStorage.usertoken;
    axios.get(config.get('API_URL') + '/brandemi/findAllManufacturers', {
      headers: {
        Authorization: ` ${token}`
      }
    })
      .then(response => {
        console.log(response);
        let party_list = [];
        response.data.map((values, index) => {
          if (values.party_name !== 'Admin') {
            party_list.push({ value: values.id, label: values.party_name });
          }
        });
        this.setState({
          party_list: party_list,
          loading: false
        });
      })
      .catch(error => {
        console.error("Error fetching party list:", error);
        this.setState({ loading: false });
      });
  };

  updatePartyValue(optionSelected) {
    this.setState({
      loading: true
    })
    let value = '';
    let partyArray = [];
    if (optionSelected.length < 1) {
      value = null;
      partyArray = '';
    } else {
      optionSelected.map((partyids, i) => {
        partyArray.push(partyids.value)
      });
    }
    this.setState({
      partyID: partyArray,
      partyValue: optionSelected,
      uploadDropdown: false,
      loading: false,
    }, () => {
      setTimeout(() => this.getBrandUploadedData(), 0);
      }
    );
  };

  _onEmiChecked() {
    this.setState({
      partyTypeValue: [],
      partyValue: [],
      displaySchemeDiv: 'block',
      enableDisablePartyType: 'block'
    });

    localStorage.setItem('locFlexipay', '0');

    this.getBrandUploadedData();
  }

  _onFlexypayChecked() {

    this.setState({
      partyTypeValue: [{value: "Brand", label: "Brand"}],
      partyValue: [{value: 35, label: "Default"}],
      displaySchemeDiv: 'block',
      enableDisablePartyType: 'none'
    })

    localStorage.setItem('locFlexipay', '1');

    this.getBrandUploadedData();
  }

  render() {

    const { party_list, partyValue } = this.state;

    const MenuList = props => {
      const rows = props.children;
      let no_of_rows = 0;
      let drop_down_heigth = 0
      if (rows.length !== undefined) {
        no_of_rows = rows.length;
        if (no_of_rows < 9) {
          drop_down_heigth = 40 * no_of_rows;
        } else {
          drop_down_heigth = 300;
        }

      }
      const rowRenderer = ({key, index, isScrolling, isVisible, style}) => (
        <div key={key} style={style}>{rows[index]}</div>
      );

      return (
        <List
          style={{width: '100%'}}
          width={300}
          height={drop_down_heigth}
          rowHeight={30}
          rowCount={no_of_rows}
          rowRenderer={rowRenderer}
        />
      )
    }
    const customStyles = {
      control: provided => ({
        ...provided,
        padding: "0px",
        minHeight: "15px",
      }),
      indicatorsContainer: provided => ({
        ...provided,
        height: "23px"
      }),
      clearIndicator: provided => ({
        ...provided,
        padding: "5px"
      }),
      dropdownIndicator: provided => ({
        ...provided,
        padding: "5px"
      }),
      valueContainer: base => ({
        ...base,
        padding: '0px 6px'
      }),
      menu: styles => ({...styles, zIndex: 999})
    };

    let menus = this.state.emiMenus.map((menu, index) => {
      return (
        <NavItem key={index} eventKey={index + "_" + 5} componentClass={Link} href={menu.layout + menu.path}
                 to={menu.layout + menu.path}>
          {menu.name}
        </NavItem>
      )
    });

    return (
      <div className="longcontent">
        <CommonNavbar/>
        <div className="container-fluid">
          <div className="card" style={{marginBottom: '-2px', paddingLeft: '10px'}}>
            <input type="radio" name="same" onChange={this._onEmiChecked.bind(this)} checked={true} /><small>EMI</small>
            &nbsp; &nbsp; &nbsp;
{/*             <input type="radio" name="same" onChange={this._onFlexypayChecked.bind(this)}/><small>Flexipay</small> */}
          </div>

          <div className="card-query-builder top-pad-5" style={{display: this.state.displaySchemeDiv}}>
            <NotificationSystem ref="notificationSystem" style={style}/>
            <ReactTooltip/>
            <div className="pt-5">
              <div className="card">
                <div className="header">

                  <h4 className="title pull-left">Issuer Banks</h4>

                </div>

                <div className="content">
                  <div className="row">
                    <div className="container-fluid">
                      <div className="table-full-width table-responsive-bemi notablerightmargin top-pad-5">
                        <table className="table table-striped table-hover" id="schemesViewTable">
                          <thead>
                          <tr>
                            <th>ID</th>
                            <th>Issuer Bank</th>
                            <th>Cashback Flag</th>
                            <th>Min EMI Amount</th>
                            <th>T&C</th>
                            <th>Action</th>
                          </tr>
                          </thead>
                          <tbody>
                          {}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminIssuerBanksList;